exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AuthPhoneScreen p {\n  text-align: center;\n  margin-bottom: 24px; }\n\n.AuthPhoneScreen .Button {\n  float: right;\n  margin-left: 12px; }\n\n.AuthPhoneScreenResend {\n  float: left !important;\n  margin-left: 0 !important;\n  margin-top: 12px;\n  color: #0088c0;\n  text-decoration: underline; }\n  .AuthPhoneScreenResendDisabled {\n    pointer-events: none;\n    color: #5c5c5c;\n    text-decoration: none; }\n", ""]);

// exports
